import React, { useState } from 'react';
import { 
  Box, 
  Textarea, 
  VStack, 
  Heading, 
  ChakraProvider,
  extendTheme,
  CSSReset,
  Container
} from '@chakra-ui/react';
import MarkdownRenderer from '../../components/MarkdownRenderer';

// Create a custom theme that matches the main app
const theme = extendTheme({
  fonts: {
    heading: '"Lexend", sans-serif',
    body: '"Lexend", sans-serif',
  },
  styles: {
    global: () => ({
      'html, body': {
        fontFamily: '"Lexend", sans-serif',
        lineHeight: 'tall',
        letterSpacing: '0.01em',
        bg: 'white',
        color: 'gray.800',
      },
      p: {
        marginBottom: '1em',
        lineHeight: '1.6',
      },
    }),
  },
});

const MarkdownTestPage: React.FC = () => {
  const [markdown, setMarkdown] = useState<string>(
    '# Markdown Test\n\n' +
    '## This is a test page\n\n' +
    'You can type markdown in the textarea below to test the renderer.\n\n' +
    '### Features\n' +
    '- **Bold** and *italic* text\n' +
    '- `Inline code` and code blocks\n' +
    '```javascript\n' +
    'function test() {\n' +
    '  console.log("Hello, world!");\n' +
    '}\n' +
    '```\n' +
    '- [Links](https://example.com)\n' +
    '> Blockquotes\n' +
    '> With multiple lines'
  );

  return (
    <ChakraProvider theme={theme}>
      <CSSReset />
      <Container maxW="container.xl" py={8}>
        <Box p={6} borderWidth="1px" borderRadius="lg" bg="white" boxShadow="sm">
          <VStack spacing={8} align="stretch">
            <Heading size="xl" color="gray.800">Markdown Renderer Test</Heading>
            
            <Box>
              <Heading size="md" mb={3} color="gray.700">Input</Heading>
              <Textarea
                value={markdown}
                onChange={(e) => setMarkdown(e.target.value)}
                minH="200px"
                fontFamily="mono"
                p={4}
                borderWidth="1px"
                borderRadius="md"
                borderColor="gray.200"
                _hover={{ borderColor: 'gray.300' }}
                _focus={{
                  borderColor: '#C200FB', // RL Purple
                  boxShadow: '0 0 0 1px #C200FB',
                }}
                _focusVisible={{
                  outline: 'none',
                }}
              />
            </Box>

            <Box>
              <Heading size="md" mb={3} color="gray.700">Rendered Output</Heading>
              <Box 
                p={6}
                borderWidth="1px"
                borderColor="gray.200"
                borderRadius="md"
                minH="200px"
                bg="white"
                boxShadow="sm"
              >
                <MarkdownRenderer content={markdown} />
              </Box>
            </Box>
          </VStack>
        </Box>
      </Container>
    </ChakraProvider>
  );
};

export default MarkdownTestPage;
